import {createSlice, configureStore} from '@reduxjs/toolkit';
import * as Simulator from '../utils/simulator';

export const simulatorStates = {
    RESET: 'reset',
    RUNNING: 'running',
    PAUSED: 'paused'
}

const plant = Simulator.RacletteOven;

const simulatorSlice = createSlice({
    name: 'simulator',
    initialState: {
        simulatorState: simulatorStates.RESET,
        controllerType: Simulator.TwoPositionController.getName(),
        plant: plant.getName(),
        u_man: 2,
        r: 120, // 10
        e_lower: -3,
        e_middle1: -1.5,
        e_middle2: 1.5,
        e_upper: 3,
        u_max: plant.u_max,
        u_min: plant.u_min,
        u_lower: 0, // -15
        u_middle: 115, // 0
        u_upper: 230, // 15
        k_p: 10,
        t_i: 0,
        t_d: 0,
        t_f: 0,
        timeLimit: 10,
        antiWindup: true,
        returnYNegative: true,
        data: [],
    },
    reducers: {
        changeController: (state, action) => {
            state.controllerType = action.payload;
            state.simulatorState = simulatorStates.RESET;
            state.data = [];
        },
        changePlant: (state, action) => {
            state.plant = action.payload;
            state.simulatorState = simulatorStates.RESET;
            state.data = [];
        },
        updateNumericValue: (state, action) => {
            const value = parseFloat(action.payload.value);
            if (!isNaN(value)) {
                state[action.payload.key] = value;
            }
        },
        setNewData: (state, action) => {
            state.data = state.data.concat(action.payload)
            if(state.timeLimit){
                while(state.data[state.data.length - 1]?.time > state.data[0].time + state.timeLimit){
                    state.data.shift();
                }
            }
        },
        toggleSimulatorState: (state) => {
            if(state.simulatorState === simulatorStates.RUNNING){
                state.simulatorState = simulatorStates.PAUSED;
            } else{
                state.simulatorState = simulatorStates.RUNNING;
            }
        },
        resetSimulation: (state) => {
            state.simulatorState = simulatorStates.RESET;
            state.data = [];
        },
        setTimeLimit: (state, action) => {
            if(!isNaN(action.payload)){
                state.timeLimit = action.payload;
                while(state.data[state.data.length - 1]?.time > state.data[0]?.time + state.timeLimit){
                    state.data.shift();
                }
            }
        },
        // removeTimeLimit: (state) => {
        //     state.timeLimit = undefined;
        // },
        setAntiWindup: (state, action) => {
            state.antiWindup = action.payload;
        },
        setReturnYNegative: (state, action) => {
            state.returnYNegative = action.payload;
        }
    }
});

const appSlice = createSlice({
    name: 'app',
    initialState: {
        settingsOpen: false,
    },
    reducers: {
        openSettings: (state) => {
            state.settingsOpen = true;
        },
        closeSettings: (state) => {
            state.settingsOpen = false;
        }
    }
})

const store = configureStore({
    reducer: {simulator: simulatorSlice.reducer, app: appSlice.reducer}
});


export const simulatorActions = simulatorSlice.actions;
export const appActions = appSlice.actions;
export default store;